<template>
    <div id="app" v-touch:right="onSwipeLeft">
        <router-view />


        <!-- 登录弹窗 -->

        <div class="login-wrap" v-show="is_show_wrap" @click="is_show_wrap = false">

            <div class="login-form" v-show="is_show_login" @click.stop="a = 1">

                <div class="lg-title">Entrar</div>

                <div class="item mt">
                    <span class="icon">
                        <img src="./views/images/login/phone_a.png" alt="" />
                    </span>
                    <input type="text" class="inp" v-model.trim="data.username" :placeholder="$t('请输入手机号码或邮箱')" />
                </div>

                <div class="item mt">
                    <span class="icon">
                        <img src="./views/images/login/pwd_a.png" alt="" />
                    </span>
                    <input type="password" class="inp" v-model.trim="data.password" :placeholder="$t('请输入密码')" />
                </div>


                <div class="remeber">
                    <div class="rem-left">
                        <img src="./views/images/login/remeber.png" alt="" />
                        <span>{{ $t("记住我") }}</span>
                    </div>
                    <div class="rem-right" @click="is_show_reset = true; is_show_login = false; is_show_register = false;">
                        {{
                            $t("忘记密码") }}</div>
                </div>


                <div class="lg-btn" @click="submit_login()">{{ $t("登录") }}</div>

                <div class="rg-btn" @click.stop="register()">
                    {{ $t("还没账号?") }}
                    <span class="signup">{{ $t("立即注册") }}</span>
                </div>

            </div>

            <!-- 注册 -->
            <div class="login-form" v-show="is_show_register" @click.stop="a = 1">

                <div class="lg-title">Registro</div>

                <div class="item mt">
                    <span class="icon">
                        <img src="./views/images/login/phone_a.png" alt="" />
                    </span>
                    <input type="text" class="inp" v-model.trim="register_data.mobile" :placeholder="$t('请输入您的手机号')" />
                </div>

                <div class="item mt">
                    <span class="icon">
                        <img src="./views/images/login/pwd_a.png" alt="" />
                    </span>
                    <input type="password" class="inp" v-model.trim="register_data.password" :placeholder="$t('请设置登录密码')" />
                </div>

                <div class="item mt">
                    <span class="icon">
                        <img src="./views/images/login/pwd_a.png" alt="" />
                    </span>
                    <input type="password" class="inp" v-model.trim="register_data.spassword" :placeholder="$t('重复登录密码')" />
                </div>


                <div class="now-btn" @click="submit_reigster"> {{ $t("立即注册") }}</div>

                <div class="rg-btn" @click.stop="login()">
                    {{ $t("已有账号?") }}
                    <span class="signup"> {{ $t("立即登录") }}</span>
                </div>

            </div>

            <!-- 重置密码 -->
            <div class="login-form" v-show="is_show_reset" @click.stop="a = 1">

                <div class="lg-title">Redefinir Senha</div>

                <div class="item mt">
                    <span class="icon">
                        <img src="./views/images/login/phone_a.png" alt="" />
                    </span>
                    <input type="text" class="inp" v-model.trim="reset_data.mobile" :placeholder="$t('请输入您的手机号')" />

                </div>

                <div class="item mt">

                    <input type="text" class="inp" v-model.trim="reset_data.sms" :placeholder="$t('短信验证码')" />
                    <button class="fason" @click="sendcode">{{ showTime > 0 ? showTime : $t("发送") }}</button>
                </div>

                <div class="item mt">
                    <span class="icon">
                        <img src="./views/images/login/pwd_a.png" alt="" />
                    </span>
                    <input type="password" class="inp" v-model.trim="reset_data.password" :placeholder="$t('请设置登录密码')" />
                </div>




                <div class="now-btn" @click="reset_password">{{ $t("修改密码") }}</div>

                <div class="rg-btn" @click.stop="login()">
                    {{ $t("已有账号?") }}
                    <span class="signup"> {{ $t("立即登录") }}</span>
                </div>

            </div>


        </div>

        <!-- 底部导航 -->
        <div v-if="is_show_footer" class="footer">
            <router-link to="/" class="footer_item" :class="show_icon_type === 'index' ? 'footer_item_active' : ''">
                <span class="footer_icon footer_icon_home" />
                <p class="footer_info">
                    Jogos
                </p>
            </router-link>

            <router-link to="/myteam" class="footer_item" :class="show_icon_type === 'share' ? 'footer_item_active' : ''">
                <span class="footer_icon footer_icon_cart" />
                <p class="footer_info">
                    Share
                </p>
            </router-link>

            <router-link to="/invest" class="footer_item" :class="show_icon_type === 'invest' ? 'footer_item_active' : ''">
                <span class="footer_icon footer_icon_recharge" />
                <p class="footer_info">
                    Depósito
                </p>
            </router-link>

            <router-link to="/item" class="footer_item" :class="show_icon_type === 'item' ? 'footer_item_active' : ''">
                <span class="footer_icon footer_icon_task" />
                <p class="footer_info">
                    Atividade
                </p>
            </router-link>

            <router-link to="/reward" class="footer_item" :class="show_icon_type === 'reward' ? 'footer_item_active' : ''">
                <span class="footer_icon footer_icon_user" />
                <p class="footer_info">
                    Bônus
                </p>
            </router-link>

            <img src="./views/images/home/btm_bg.png" class="btm-bg" alt="">
        </div>

    </div>
</template>

<script>
import Vue from "vue";
import { Notify } from 'vant';
import router from './router';
import Fetch from "./utils/fetch";
Vue.use(Notify);
export default {
    name: 'App',
    data() {
        return {
            show_icon_type: 'index',
            real_name: false,
            is_show_down_app: true,
            is_show_footer: true,
            is_show_wrap: false,
            is_show_login: false,
            is_show_register: false,
            is_show_reset: false,
            sync_timer: null,
            showTime: 0,
            app: {},
            data: {
                username: "",
                password: "",
            },
            register_data:
            {
                password: "",
                spassword: "",
                mobile: "",
                invitation_code: localStorage.getItem("code") || null,
                sms: "",
            },
            reset_data:
            {
                password: "",
                spassword: "",
                mobile: "",
                sms: "",
            }
        }
    },
    updated() {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
    },
    mounted() {
        let _this = this;
        router.beforeEach((to, from, next) => {
            let token = localStorage.getItem('token');
            console.log(token);
            console.log(888999);
            if (!token) {
                _this.login()
                return false;
            }
            return next();
        });
        this.data.username = localStorage.getItem("login_username");
        this.data.password = localStorage.getItem("login_password");
    },
    methods: {
        sendcode() {
            if (!this.reset_data.mobile) {
                Notify({ type: 'danger', message: this.$t("手机号码不能为空") });
                return false;
            }
            Fetch("/sms/send", {
                mobile: this.reset_data.mobile,
                event: 'resetpwd',
            }).then(() => {
                this.time = 120 * 1000;
                this.showTime = 120;
                this.timeId = setInterval(() => {
                    this.showTime--;
                }, 1000);
                Notify({ type: 'primary', message: this.$t("发送成功") });

            }).catch(() => {

            });
        },
        reset_password() {

            if (!this.reset_data.mobile) {
                Notify({ type: 'danger', message: this.$t("手机号码不能为空") });
                return false;
            }

            if (!this.reset_data.password) {
                Notify({ type: 'danger', message: this.$t("密码长度为6-18位") });
                return false;
            }

            if (this.reset_data.password.length < 6) {
                Notify({ type: 'danger', message: this.$t("密码长度为6-18位") });
                return false;
            }

            if (!this.reset_data.sms) {
                this.$toast(this.$t("短信验证码不能为空"));
                return;
            }

            Fetch("/user/resetpwd", {
                mobile: this.reset_data.mobile,
                newpassword: this.reset_data.password,
                sms: this.reset_data.sms,
            }).then((res) => {
                if (res.code == 1) {
                    Notify({ type: 'success', message: "Modificado com sucesso" });
                    setTimeout(() => {
                       this.login();
                    }, 2000);
                } else {
                  
                    Notify({ type: 'danger', message:res.msg });
                }

            });
            return;

        },
        submit_reigster() {
            this.register_data.invitation_code = localStorage.getItem("code") ? localStorage.getItem("code") : null;
            if (!this.register_data.mobile) {
                Notify({ type: 'danger', message: this.$t("手机号码不能为空") });
                return false;
            }
            if (!this.register_data.password) {
                Notify({ type: 'danger', message: this.$t("密码长度为6-18位") });
                return false;
            }
            if (this.register_data.password.length < 6) {
                Notify({ type: 'danger', message: this.$t("密码长度为6-18位") });
                return false;
            }
            if (this.register_data.password != this.register_data.spassword) {
                Notify({ type: 'danger', message: this.$t("两次密码不一致") });
                return false;
            }
            this.register_data.mobile = this.register_data.mobile.replace(new RegExp("[+]", "gm"), "");
            Fetch("/user/register", this.register_data)
                .then((res) => {
                    //console.log(res);
                    if (res.code == 1) {
                        //注册成功
                        Notify({ type: 'success', message: this.$t("注册成功") });
                        localStorage.setItem("login_username", this.register_data.mobile);
                        setTimeout(() => {
                            this.login();
                        }, 3000);
                    } else {
                        Notify({ type: 'danger', message: res.msg });
                    }
                })
                .catch((e) => {
                    Notify({ type: 'danger', message: this.$t("系统繁忙,请稍后再尝试") });
                    return false;
                });
        },
        submit_login() {
            if (!this.data.username) {
                Notify({ type: 'danger', message: this.$t("请输入正确的手机号码") });
                return;
            }
            if (!this.data.password) {
                Notify({ type: 'danger', message: this.$t("密码为6-18位") });
                return;
            }
            this.data.username = this.data.username.replace(new RegExp("[+]", "gm"), "");
            Fetch("/user/login", {
                account: this.data.username,
                password: this.data.password,
            }).then((res) => {

                //登录失败
                if (res.code == 0) {
                    Notify({ type: 'danger', message: res.msg });
                } else {
                    if (res.data.userinfo.token) {
                        localStorage.setItem("token", res.data.userinfo.token);
                    }
                    Notify({ type: 'success', message: this.$t("登录成功") });
                    //保存账户密码
                    localStorage.setItem("login_username", this.data.username)
                    localStorage.setItem("login_password", this.data.password)
                    //跳转到首页
                    setTimeout(() => {
                        window.location.href = "/";
                    }, 1000);
                }
            });

        },
        login() {
            this.data.username = localStorage.getItem("login_username") ? localStorage.getItem("login_username") : "";
            this.is_show_wrap = true;
            this.is_show_register = false;
            this.is_show_reset = false;
            this.is_show_login = true;
            return;
        },
        register() {
            this.is_show_wrap = true;
            this.is_show_login = false;
            this.is_show_reset = false;
            this.is_show_register = true;
            return;
        },
        onSwipeLeft(even, start, end) {
            //console.log(window.location.href);

            if (window.location.href.indexOf('signature')) {
                return false;
            }
            if (end['X'] - start['X'] > 60) {
                this.$router.go(-1);
            }
        },
        bigNumeber(str) {
            var str = str.toString();
            var strs = str.split(".");
            var s1 = strs[0] || 0;
            var s2 = strs[1] || "00"
            return `<span class="bigNum">${s1}</span><span>.</span><span>${s2}</span>`;
        },
        numFilter(value) {
            let transformVal = parseFloat(value).toFixed(3)
            let realVal = transformVal.substring(0, transformVal.length - 1)
            return parseFloat(realVal)
        },
        footer: function (type = 'index', show_footer = true) {
            if (type == 'walfare') {
                document.getElementById('app').style.paddingBottom = '0';
            } else {
                document.getElementById('app').style.paddingBottom = '1.333333rem';
            }
            this.show_icon_type = type;
            this.is_show_footer = show_footer;
        },

        closeDownApp() {
            this.is_show_down_app = false;
        },
        sync() {
            /* Fetch("/index/sync", {}, null, false).then((r) => {
                 if (r.data.is_open_notice_dialog) {
                     this.openNoticeDialog();
                 }
             }); */
        },
        close() {
            this.show_anwser = false;
        },
        openNoticeDialog() {

        },
    }
}
</script>
<style lang="less">
@maincolor: #84A559;
@wd: 8rem;

.fason {
    color: #fff;
    height: 0.85rem;
    width: 1.3rem;
    font-size: 0.35rem;
    border: 1px solid #84A559;
    background-color: #95BF5F;
}

.btm-bg {
    height: 1rem;
    position: absolute;
    top: -0.85rem;
}

.signup {

    color: @maincolor;
}

.rg-btn {
    text-align: center;
    color: #C7DFA9;
    height: 1.3rem;
    line-height: 1.3rem;
}

.lg-btn {
    width: 85%;
    height: 1.1rem;
    line-height: 1.1rem;
    text-align: center;
    background-color: @maincolor;
    margin: 0.2rem auto;
    border-radius: 0.15rem;
    color: #C7DFA9;
    font-size: 0.35rem;
}

.now-btn {
    width: 85%;
    height: 1.1rem;
    line-height: 1.1rem;
    text-align: center;
    background-color: @maincolor;
    margin: 0.5rem auto;
    border-radius: 0.15rem;
    color: #C7DFA9;
    font-size: 0.35rem;
    margin-bottom: 0.2rem;
}

.rem-right {
    color: @maincolor;
    display: flex;
    align-items: center;
    justify-items: flex-end;
}

.rem-left img {
    width: 0.35rem;
    height: 0.35rem;
    margin-right: 0.2rem;
}

.rem-left {
    width: 50%;
    display: flex;
    align-items: center;
    color: @maincolor;
}

.remeber {
    height: 1.2rem;
    width: 85%;
    margin: 0 auto;
    // background: #84A559;
    margin-top: 0.2rem;
    display: flex;
    justify-content: space-between;
}

.login-form .mt {
    margin-top: 0.5rem;
}

.item {
    box-sizing: border-box;
    width: 85%;
    height: 0.85rem;
    font-size: 0.2rem;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    box-sizing: content-box;
    border: 1px solid @maincolor;
    border-radius: 6px;
    margin: 5px auto;

    .icon {
        width: 0.8rem;
        height: 100%;

        img {
            display: block;
            margin: 0.225rem auto;
            width: 0.35rem;
            height: 0.4rem;
        }
    }

    input {
        height: 0.85rem;
        line-height: 0.65rem;
        margin-left: 7px;
        flex: 1;
        color: @maincolor;
        font-size: 0.4rem;
    }

    input::placeholder {
        color: @maincolor;
        font-size: 0.3rem;
    }
}

.lg-title {
    color: #84A559;
    font-size: 0.4rem;
    font-weight: 700;
    text-align: center;
    line-height: 1rem;
    height: 1rem;
}

.login-form {
    width: @wd;
    // height: 8.5rem;
    border: 1px solid @maincolor;
    position: absolute;
    top: 25%;
    left: 50%;
    margin-left: -@wd/2;
    border-radius: 0.2rem;
    background: rgba(14, 21, 20, 0.8);
}

.login-wrap {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 99;
}



// @import "./assets/font/font.css";
.tabbar-item-cz-text-qstJE {
    font-size: 0.3rem;
    font-weight: 700;

    animation: tabBarBlink-BwOOG 1.5s ease 0s infinite normal none running
}

.tabbar-item-gif-wXsFN {
    width: 26px;
    height: 26px;
    margin-bottom: .08rem
}

.tabbar-item-cz-lbsA7 {
    border: .12rem solid var(--cms-mango-background-color3);
    background-size: cover;
    border-radius: 50%;
    width: 1.75rem;
    color: #95BF5F;
    text-align: center;
}

.logo {
    width: 114px;
    height: 24px;
    margin-left: 8px;
    margin-top: 8px;
}

.mt44 {
    margin-top: 44px;
}

.kefu {
    width: 40px;
    height: 40px;
    position: fixed;
    z-index: 10;
    right: 8px;
    bottom: 64px;
    transition: all 1s;
    opacity: 1;
    transform: translateX(0);
    z-index: 80;

    img {
        width: 40px;
        height: 40px;
    }
}

.kefu.kefu_hide {
    transform: translateX(70%);
    opacity: 0.5;
}

.numberFont {
    font-family: barlow !important;
    font-size: 15px !important;
    font-weight: bold !important;

    span:nth-of-type(3) {
        font-size: 14px !important;
    }

    span:nth-of-type(4) {
        font-size: 12px !important;
    }
}

html,
body {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    // font-family: "微软雅黑" !important;
    font-family: Helvetica !important;
    user-select: none !important;
    ;
}

html::-webkit-scrollbar,
body::-webkit-scrollbar {
    width: 0px;
    height: 0px;
}

body {
    margin: 0;
}

.bigNum {
    font-size: 18px !important;
}

.fh {
    font-size: 12px !important;
}

.larfont .fh {
    margin-top: 3px;
}

.wan {
    font-size: 14px;
    margin-top: 2px;
}

.numberFontBold {
    span:first-child {
        font-size: 12px;
        margin-top: 4px;
    }

    span:last-child {
        margin-top: 2px;
    }
}

#app {
    padding-bottom: 65px !important;
    min-height: 100%;
    height: auto;
    width: 100%;
    max-width: 375px;

    background: url('./views/images/vip/sbg.png') repeat;

}

#app .download_box {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    position: fixed;
    margin: 0 auto;
    left: 0;
    right: 0;
    height: 45px;
    width: 100%;
    max-width: 375px;
    background: rgba(0, 0, 0, 0.5);
    bottom: 50px;
    padding: 0 3.6%;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    z-index: 10;
}

#app .download_box .down {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding-right: 10px;
}

#app .download_box .down .down_left {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

#app .download_box .down .down_left .app_logo {
    display: inline-block;
    width: 40px;
    height: 40px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    background-image: url(./views/images/home/app_logo.svg);
    margin-right: 14px;
    ;
}

#app .download_box .down .down_left .app_info {
    font-size: 12px;
    color: #fff;
    line-height: 1.5;
    ;
}

#app .download_box .down .right {
    background: #D8232C;
    padding: 5px 5px;
    color: #ffffff;
    border-radius: 5px;
    font-size: 12px;
}

#app .download_box .close_down {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 20px;
    flex: 0 0 20px;
    height: 45px;
    ;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    background-image: url(./views/images/home/close.svg);
}

#app .footer {
    position: fixed;
    margin: 0 auto;
    left: 0;
    right: 0;
    max-width: 415px;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 48px;
    flex: 0 0 48px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background: #000000;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
    width: 100%;
    bottom: 0;
    height: 60px;
    z-index: 9999;
}

#app .footer .footer_item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    cursor: pointer;
    color: #999999;
    width: 60px;
}

#app .footer .footer_item .footer_icon {
    display: inline-block;
    width: 26px;
    height: 26px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
}

#app .footer .footer_item .footer_icon.footer_icon_home {
    background-image: url(./views/images/nav/jogo.png);
}

#app .footer .footer_item .footer_icon.footer_icon_cart {
    background-image: url(./views/images/nav/share.png);
}

#app .footer .footer_item .footer_icon.footer_icon_recharge {
    background-image: url(./views/images/nav/recharge.png);
}

#app .footer .footer_item .footer_icon.footer_icon_task {
    background-image: url(./views/images/nav/active.png);
}


#app .footer .footer_item .footer_icon.footer_icon_user {
    background-image: url(./views/images/nav/bonus.png);
}

#app .footer .footer_item .footer_info {
    font-size: 12px;
    color: #999;
}

#app .footer .footer_item.footer_item_active .footer_info {
    color: #fff !important;
    font-weight: 700;
}

#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_home {
    background-image: url(./views/images/nav/jogo_a.png);
}

#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_cart {
    background-image: url(./views/images/nav/share_a.png);
}

#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_recharge {
    background-image: url(./views/images/nav/recharge_a.png);
}

#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_task {
    background-image: url(./views/images/nav/share_a.png);
}

#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_user {
    background-image: url(./views/images/nav/bonus_a.png);
}

.red_top_bg {
    width: 100%;
    max-width: 415px;
    height: 44px;
    margin: 0 auto;
    //background: #FFF;
    background-size: 100% 100%;
    overflow: hidden;
}

.top_right {
    position: absolute;
    font-size: 13px;
    line-height: 18px;
    color: #FFFFFF;
    top: 16px;
    right: 14px;
}

.limit {
    height: 20px;
    line-height: 20px;
    border-radius: 10px;
    background: rgba(241, 34, 17, 0.08);
    color: #f12211;
    text-align: center;
    padding: 0 7px;
    border: 1px solid #f12211;
    font-size: 12px;
}

.gray_btn {
    height: 20px;
    display: flex;
    align-items: center;
    background: rgba(0, 0, 0, 0.3);
    font-size: 12px;
    text-align: center;
    color: #FFFFFF;
    border-radius: 10px;
    padding: 0 9px;
}


.sub_btn {
    background: linear-gradient(123deg, #e3382e, #ff4d15);
    height: 36px;
    line-height: 36px;
    font-size: 12px;
    color: #FFFFFF;
    text-align: center;
    width: 94px;
    border-radius: 18px;
}

.remove_btn {
    background: linear-gradient(117deg, rgba(254, 166, 0, 1) 0%, rgba(255, 188, 0, 1) 100%);
    height: 36px;
    line-height: 36px;
    font-size: 12px;
    color: #FFFFFF;
    text-align: center;
    width: 94px;
    border-radius: 18px;
}

.home_tit {
    width: 100%;
    height: 22px;
    line-height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;

    .line {
        width: 75px;
        height: 2px;
    }

    h5 {
        font-size: 16px;
        line-height: 22px;
        color: #000000;
        margin: 0 10px;
        font-weight: bold;
    }
}

.van-popup {
    max-width: 100%;
    margin: 0 auto;
    right: 0;
}

.back_left {
    //width: 20px;
    //height: 20px;
    height: 100%;
    width: 30px;
    //background: url(./views/images/item/back.png) no-repeat center center;
    background-size: 25px 25px;
    //margin: 12px 0 0 8px;
}

.basic_btn {
    height: 45px;
    line-height: 45px;
    font-size: 16px;
    width: 90%;
    background: linear-gradient(90deg, rgba(228, 57, 46, 1) 0%, rgba(255, 77, 22, 1) 100%);
    border-radius: 23px;
    color: #FFFFFF;
    text-align: center;
}

.basic_btn.no_touch {
    color: rgba(255, 255, 255, 0.5);
}

.flex_center {
    display: flex;
    justify-content: center;
    align-items: center;
}

.wrap_box {
    width: 100%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
    border-radius: 6px;
}

.eye_bi {
    width: 21px;
    height: 25px;
    background: url(./views/images/user/eye3.png) no-repeat center center;
    background-size: 100% auto;

    &.eye {
        background: url(./views/images/user/eye1.png) no-repeat center center;
        background-size: 100% auto;
    }
}

.real_name_mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 30;
    background-color: rgba(0, 0, 0, 0.95);

    .real_box {
        width: 272px;
        height: 185px;
        background: rgba(255, 255, 255, 1);
        border-radius: 8px;
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        margin: -92px auto 0 auto;

        .tit {
            width: 77px;
            height: 67px;
            position: absolute;
            top: -35px;
            left: 50%;
            transform: translateX(-50%);
            background: url(./views/images/user/tit.png) no-repeat center center;
            background-size: 100% 100%;
        }

        .tips {
            width: 185px;
            height: 50px;
            text-align: center;
            font-size: 18px;
            color: #000000;
            line-height: 25px;
            position: absolute;
            top: 49px;
            left: 50%;
            transform: translateX(-50%);
        }

        .basic_btn {
            width: 225px;
            position: absolute;
            left: 0;
            right: 0;
            margin: 0 auto;
            bottom: 15px;
        }
    }
}

.contract_box img {
    width: 100%;
}
</style>
